import {
  ChatRoomRestService,
  ChatMessageRestService,
} from './restServices/restServices';
import storageService from './storageService';
import utilsService from './utilsService';

var service = {};
service.fldObj = {};
if (!service.fncObj) {
  service.fncObj = {};
}
if (!service.fncObj.peerSpecificFnc) {
  service.fncObj.peerSpecificFnc = {};
}

service.getCreateChatRoomByOwnerAndGuests = (
  ownerObjectType,
  ownerObjectId,
  guestUserIds,
  successCallbackFunction,
  failureCallbackFunction,
) => {
  const ownerParticipant = {
    objectType: ownerObjectType,
    objectId: ownerObjectId,
  };
  if (guestUserIds.length < 1) {
    console.debug(
      'Need to provide more than 1 guest userId in order to access a chatRoom',
    );
    return;
  }
  let requestObject = {
    token: storageService.getItem('token'),
    guestUserIds,
    ownerParticipant,
  };

  ChatRoomRestService.save(
    {
      endpoint: 'users',
    },
    requestObject,
    (resource) => {
      // console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource.chatRoomDto);
      }
    },
    (error) => {
      // console.debug(response);
      if (failureCallbackFunction) {
        failureCallbackFunction(error);
      }
    },
  );
};

service.updateChatroomByChatroomId = function (
  roomId,
  roomInfoDto, // notes, peerName, todo:boolean
  successCallbackFunction,
) {
  //expected roomInfoDto structure
  //   {
  //     "chatRoomPeerInfoDto": {
  //             "notes": "abc",
  //             "peerName": "abc",
  //             "todo": false
  //     },
  //     "roomInfoDto": {
  //         "roomName": "room name",
  //         "notes": "notes",
  //         "todo": false
  //     },
  //     "token": ""
  // }
  roomInfoDto.token = storageService.getItem('token');
  ChatRoomRestService.update(
    {
      endpoint: 'roomId',
      endpointParam: roomId,
    },
    roomInfoDto,
    function (resource) {
      // console.debug(resource);
      successCallbackFunction(resource.chatRoomDto);
    }, // success
    function (/* response */) {
      // console.debug(response);
    },
  ); // failure
};

service.deleteChatroomByChatroomId = function (
  chatRoomId,
  successCallbackFunction,
  failureCallbackFunction,
) {
  const reqObject = {
    endpoint: 'chatRoomId',
    endpointParam: chatRoomId,
    token: storageService.getItem('token'),
  };
  ChatRoomRestService.delete(
    reqObject,
    reqObject,
    function (resource) {
      // console.debug(resource);
      if (successCallbackFunction)
        successCallbackFunction(resource.chatRoomDto);
    }, // success
    function (response) {
      if (failureCallbackFunction) failureCallbackFunction(response);
    },
  ); // failure
};

service.transitionChatRoomOwnership = function (
  chatRoomId,
  newTaskOwnerMentorId,
  successCallbackFunction,
  failureCallbackFunction,
) {
  let requestObj = {
    chatRoomId,
    newTaskOwnerMentorId,
    token: storageService.getItem('token'),
  };
  ChatRoomRestService.update(
    {
      endpoint: 'transitionTaskOwnership',
    },
    requestObj,
    (response) => {
      utilsService.logApiResponse('transitionChatRoomOwnership', response);
      successCallbackFunction && successCallbackFunction(response);
    },
    (error) => {
      utilsService.logApiResponse('transitionChatRoomOwnership', error);
      failureCallbackFunction && failureCallbackFunction(error);
    },
  );
};

service.transitionToMentorChat = function (
  mentorId,
  teamChatRoomId,
  transitionChatRoomCloneRecipe,
  successCallbackFunction,
  failureCallbackFunction,
) {
  let requestObj = {
    mentorId,
    teamChatRoomId,
    transitionChatRoomCloneRecipe,
    token: storageService.getItem('token'),
  };
  ChatRoomRestService.update(
    {
      endpoint: 'transitionToMentorChat',
    },
    requestObj,
    (response) => {
      utilsService.logApiResponse('transitionToMentorChat', response);
      successCallbackFunction && successCallbackFunction(response);
    },
    (error) => {
      utilsService.logApiResponse('transitionToMentorChat', error);
      failureCallbackFunction && failureCallbackFunction(error);
    },
  );
};

service.getMessagesByChatRoomId = function (
  roomId,
  successCallbackFunction,
  failureCallbackFunction,
  token,
) {
  var requestObject = {
    token: token ? token : storageService.getItem('token'),
    endpoint: 'roomId',
    endpointParam: roomId,
  };
  ChatMessageRestService.get(
    requestObject,
    {},

    function (resource) {
      // success
      // console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource.chatMessagesDto);
      } else {
        return resource.mentorDto;
      }
    },

    function (/* response */) {
      // failure
      // console.debug(response.data);
      if (failureCallbackFunction) {
        failureCallbackFunction();
      } else {
        return null;
      }
    },
  );
};

service.deleteChatMessageByMessageId = function (
  chatMessageId,
  successCallbackFunction,
  failureCallbackFunction,
  token,
) {
  var requestObject = {
    token: token ? token : storageService.getItem('token'),
    endpoint: 'chatMessageId',
    endpointParam: chatMessageId,
  };
  ChatMessageRestService.delete(
    requestObject,
    requestObject,
    function (resource) {
      // console.debug(resource);
      if (successCallbackFunction)
        successCallbackFunction(resource.chatRoomDto);
    }, // success
    function (response) {
      if (failureCallbackFunction) failureCallbackFunction(response);
    },
  ); // failure
};

service.getAllMessagesByChatRoomId = function (
  roomId,
  pageNum,
  pageSize,
  successCallbackFunction,
  failureCallbackFunction,
  token,
) {
  var requestObject = {
    token: token ? token : storageService.getItem('token'),
    pageNumber: pageNum,
    pageSize: pageSize,
    endpoint: 'roomId',
    endpointParam: roomId,
  };
  ChatMessageRestService.get(
    requestObject,
    {},

    function (resource) {
      // success
      // console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource.chatMessagesDto);
      } else {
        return resource.mentorDto;
      }
    },

    function (response) {
      // failure
      console.debug(response.data);
      if (failureCallbackFunction) {
        failureCallbackFunction();
      } else {
        return null;
      }
    },
  );
};

service.getGuestMessagesByChatRoomId = function (
  roomId,
  userId,
  successCallbackFunction,
  failureCallbackFunction,
  token,
) {
  var requestObject = {
    token: token ? token : storageService.getItem('token'),
    // userId: userId,
    endpoint: 'guestRoomId',
    endpointParam: roomId,
    endpoint2: 'userId',
    endpointParam2: userId,
  };
  ChatMessageRestService.get(
    requestObject,
    {},

    function (resource) {
      // success
      // console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource.chatMessagesDto);
      } else {
        return resource.mentorDto;
      }
    },

    function (error) {
      // failure
      // console.debug(response.data);
      if (failureCallbackFunction) {
        failureCallbackFunction(error);
      } else {
        return null;
      }
    },
  );
};
service.getChatRoomInfoByChatRoomId = function (
  roomId,
  successCallbackFunction,
  failureCallbackFunction,
) {
  var requestObject = {
    endpoint: 'roomId',
    endpointParam: roomId,
    token: storageService.getItem('token'),
  };
  if (!requestObject.token) {
    requestObject.endpoint = 'guest/roomId';
    requestObject.endpoint2 = 'userId';
    requestObject.endpointParam2 = storageService.getItem('guestUid');
  }

  ChatRoomRestService.get(
    requestObject,
    {},
    function (resource) {
      // console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource.chatRoomDto);
      } else {
        return resource.chatRoomDto;
      }
    },
    function (error) {
      failureCallbackFunction && failureCallbackFunction(error);
    },
  );
};

service.getMessageIdByMessageTag = function (
  messageTag,
  successCallbackFunction,
  failureCallbackFunction,
) {
  var requestObject = {
    endpoint: 'chatMessageTag',
    endpointParam: messageTag,
  };
  ChatMessageRestService.get(
    requestObject,
    {},
    function (resource) {
      // console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource.chatMessageId);
      } else {
        return resource.chatMessageId;
      }
    },
    function (error) {
      failureCallbackFunction && failureCallbackFunction(error);
    },
  );
};

service.toggleMessageWasRead = function (
  chatMessageTag,
  readerUserId,
  newValue,
  successCallbackFunction,
  failureCallbackFunction,
  token,
) {
  var toggleChatMessageWasReadRequestObj = {
    chatMessageTag,
    newValue,
    readerUserId,
    token: token ? token : storageService.getItem('token'),
  };
  if (chatMessageTag === undefined || chatMessageTag === null) {
    failureCallbackFunction && failureCallbackFunction();
    return;
  }

  ChatMessageRestService.save(
    {
      endpoint: 'wasRead',
    },
    toggleChatMessageWasReadRequestObj,
    function (response) {
      // console.debug(resource);
      successCallbackFunction &&
        successCallbackFunction(response.chatMessageDto);
    }, // success
    function (/* response */) {
      // console.debug(response.data);
    },
  ); // failure
};

service.getChatRoomsByUserId = (
  userId,
  pageNum,
  pageSize,
  token,
  successCallbackFunction,
) => {
  const requestObject = {
    token: token ? token : storageService.getItem('token'),
    pageNumber: pageNum,
    pageSize: pageSize,
    endpoint: 'userId',
    endpointParam: userId,
  };
  ChatRoomRestService.get(
    requestObject,
    {},

    function (resource) {
      // console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource.chatRoomDtos);
      } else {
        return resource.chatRoomDtos;
      }
    },
    function (/* response */) {
      // failure

      // console.debug(response.data);
      return null;
    },
  );
};

service.getChatRoomsByMentorIds = (
  mentorIds,
  pageNum,
  pageSize,
  token,
  successCallbackFunction,
  failureCallbackFunction,
) => {
  const requestObject = {
    token: token ? token : storageService.getItem('token'),
    pageNumber: pageNum,
    pageSize: pageSize,
    endpoint: 'mentorIds',
    mentorIdList: mentorIds,
  };
  ChatRoomRestService.get(
    requestObject,
    {},
    function (resource) {
      // console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource.chatRoomDtos);
      } else {
        return resource.chatRoomDtos;
      }
    },
    function (response) {
      // console.debug(response.data);
      if (failureCallbackFunction) {
        failureCallbackFunction(response.data);
      } else {
        return response.data;
      }
    },
  );
};
// handle user search query
service.getSearchedContacts = (
  searchText,
  mentorIds,
  successCallbackFunction,
  failureCallback,
  token,
) => {
  const requestObject = {
    endpoint: `search`,
    searchText,
    mentorIdList: mentorIds,
    token: token ? token : storageService.getItem('token'),
  };

  ChatRoomRestService.get(
    requestObject,
    {},

    function (resource) {
      if (successCallbackFunction) {
        // todo : why this is required?
        // const res = resource;
        // let newMessages = [];
        // if (res?.messages?.length) {
        //   newMessages = res?.messages.map((msg) => {
        //     const structuredMessage = msg;

        //     if (
        //       !msg.users &&
        //       msg.readersMap &&
        //       typeof msg.readersMap === 'object'
        //     ) {
        //       structuredMessage.users = msg.readersMap;
        //     }
        //     return structuredMessage;
        //   });
        // }
        // res.messages = newMessages;
        successCallbackFunction(resource);
      } else {
        return resource;
      }
    },
    function (response) {
      // failure
      console.debug('failure', response);
      failureCallback();
      return null;
    },
  );
};

//

service.getLastUnreadChatMessages = (
  mentorIds,
  audioOnly,
  size,
  successCallbackFunction,
  failureCallbackFunction,
  token,
) => {
  const requestObject = {
    token: token ? token : storageService.getItem('token'),
    mentorIdList: mentorIds,
    audioOnly,
    size,
    endpoint: 'lastUnreadMessages',
  };
  ChatMessageRestService.get(
    requestObject,
    {},

    function (resource) {
      // console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource);
      }
    },
    function (response) {
      // failure
      // console.debug(response.data);
      failureCallbackFunction && failureCallbackFunction(response.data);
    },
  );
};

service.getFldObj = function () {
  return service.fldObj;
};

service.setFldObj = function (fldObj) {
  service.fldObj = fldObj;
};

// service.addFnc = function (newFncObj) {
//   if (!service.fncObj) {
//     service.fncObj = {};
//   }
//   UtilsService.hashMergeAToB(newFncObj, service.fncObj);
// };
// service.addPeerSpecificFnc = function (peerUserId, newFncObj) {
//   if (!service.fncObj) {
//     service.fncObj = {};
//   }
//   if (!service.fncObj.peerSpecificFnc) {
//     service.fncObj.peerSpecificFnc = {};
//   }
//   if (service.fncObj.peerSpecificFnc[peerUserId] === undefined)
//     service.fncObj.peerSpecificFnc[peerUserId] = {};
//   // console.debug(newFncObj);
//   // console.debug(service.fncObj.peerSpecificFnc);
//   UtilsService.hashMergeAToB(
//     newFncObj,
//     service.fncObj.peerSpecificFnc[peerUserId],
//   );
// };

// service.OpenChatRooms = function() {

//   service.fncObj.OpenChatRooms();
// };

service.getChatMessageByChatMessageId = (
  chatMessageId,
  successCallbackFunction,
) => {
  ChatMessageRestService.get(
    {
      endpoint: 'chatMessageId',
      endpointParam: chatMessageId,
      token: storageService.getItem('token'),
    },
    {},

    function (resource) {
      // console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource.chatMessageDto);
      } else {
        return resource.chatRoomDtos;
      }
    },
    function (/* response */) {
      // failure

      // console.debug(response.data);
      return null;
    },
  );
};
service.getMediaChatMessagesByChatRoomId = (
  roomId,
  type,
  pageNum,
  pageSize,
  successCallbackFunction,
  failureCallbackFunction,
) => {
  const requestObject = {
    token: storageService.getItem('token'),
    pageNumber: pageNum,
    pageSize: pageSize,
    endpoint: 'mediaChatMessagesByRoomId',
    endpointParam: roomId,
    type: type,
  };
  ChatMessageRestService.get(
    requestObject,
    {},

    function (resource) {
      // success
      // console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource);
      } else {
        return resource.mentorDto;
      }
    },

    function (response) {
      // failure
      console.debug(response.data);
      if (failureCallbackFunction) {
        failureCallbackFunction();
      } else {
        return null;
      }
    },
  );
};

service.createNewGroupChat = function (
  ownerObjectType,
  ownerObjectId,
  guestUserIds,
  meetingRoomId,
  successCallbackFunction,
  failureCallbackFunction,
) {
  const ownerParticipant = {
    objectType: ownerObjectType,
    objectId: ownerObjectId,
  };
  if (guestUserIds.length < 1) {
    console.debug(
      'Need to provide more than 1 guest userId in order to access a chatRoom',
    );
    return;
  }
  let requestObject = {
    token: storageService.getItem('token'),
    guestUserIds,
    ownerParticipant,
    meetingRoomId,
  };
  ChatRoomRestService.save(
    {
      endpoint: 'group',
    },
    requestObject,
    (response) => {
      console.debug('New group chat response: ', response);
      successCallbackFunction && successCallbackFunction(response);
    },
    (error) => {
      console.debug('Error: ', error);
      failureCallbackFunction && failureCallbackFunction(error);
    },
  );
};

service.addNewUserToGroupChat = function (
  requestObj,
  successCallbackFunction,
  failureCallbackFunction,
) {
  requestObj.token = storageService.getItem('token');
  ChatRoomRestService.update(
    {
      endpoint: 'group/users',
    },
    requestObj,
    (response) => {
      console.debug('addNewUserToGroupChat response: ', response);
      successCallbackFunction && successCallbackFunction(response);
    },
    (error) => {
      console.debug('Error: ', error);
      failureCallbackFunction && failureCallbackFunction(error);
    },
  );
};

service.getOwnerParticipantFromChatRoom = (chatRoomDto) => {
  const ownerParticipant = chatRoomDto.participants.find(
    (participant) =>
      participant.objectId === chatRoomDto.ownerObjectId &&
      participant.objectType === chatRoomDto.ownerObjectType,
  );
  return ownerParticipant;
};

service.toggleTaskOwnerLock = function (
  requestObj,
  successCallbackFunction,
  failureCallbackFunction,
) {
  requestObj.token = storageService.getItem('token');
  ChatRoomRestService.update(
    {
      endpoint: 'toggleTaskOwnerLock',
    },
    requestObj,
    (response) => {
      utilsService.logApiResponse('toggleTaskOwnerLock', response);
      successCallbackFunction && successCallbackFunction(response);
    },
    (error) => {
      utilsService.logApiResponse('toggleTaskOwnerLock', error);
      failureCallbackFunction && failureCallbackFunction(error);
    },
  );
};

const chatService = {...service};
export default chatService;
